const LOCAL_API_BASE_URL = "http://localhost:5000/api";

export const resolveApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
    return `${window.location.origin}/api`;
  }

  return LOCAL_API_BASE_URL;
};

export const resolveBackendAssetUrl = (url) => {
  if (!url || typeof url !== "string") {
    return null;
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  const backendOrigin = resolveApiBaseUrl().replace(/\/api\/?$/, "");
  return `${backendOrigin}${url}`;
};